import { FC } from 'react'
import { SwaggerRoutes } from '../types'
import { AccordionRouteItem } from './AccordionRouteItem'

interface AccordionTagGroupProps {
  routeType: string
  tag: string
  routes: SwaggerRoutes[]
  isExpanded: boolean
  isFullySelected: boolean
  isPartiallySelected: boolean
  selectedPermissions: number[]
  onToggleTag: (routeType: string, tag: string) => void
  onSelectAllTag: (routeType: string, tag: string) => void
  onToggleRoute: (routeId: number) => void
  getMethodColor: (method: string) => string
}

export const AccordionTagGroup: FC<AccordionTagGroupProps> = ({
  routeType,
  tag,
  routes,
  isExpanded,
  isFullySelected,
  isPartiallySelected,
  selectedPermissions,
  onToggleTag,
  onSelectAllTag,
  onToggleRoute,
  getMethodColor,
}) => {
  const tagKey = `${routeType}-${tag}`

  return (
    <div className='accordion-item'>
      <h3 className='accordion-header'>
        <button
          className='accordion-button accordion-button-sm ps-5'
          type='button'
          onClick={() => onToggleTag(routeType, tag)}
          style={{
            backgroundColor: isExpanded ? '#fafbfc' : 'white',
          }}
        >
          <div className='d-flex align-items-center gap-2 flex-grow-1'>
            <span className='badge bg-info'>{routes.length}</span>
            <span>{tag}</span>
            {isFullySelected && (
              <i className='fas fa-check-circle text-success ms-2'></i>
            )}
            {isPartiallySelected && (
              <i className='fas fa-minus-circle text-warning ms-2'></i>
            )}
          </div>
        </button>
      </h3>

      {isExpanded && (
        <div className='accordion-body p-0'>
          {/* Tag Level Select/Deselect Button */}
          <div className='p-3 border-bottom bg-light ms-4'>
            <button
              className='btn btn-success btn-sm'
              onClick={() => onSelectAllTag(routeType, tag)}
            >
              {isFullySelected ? 'Desselecionar Tag' : 'Selecionar Tag'}
            </button>
          </div>

          {/* Routes in Tag */}
          <div className='p-3 ms-4'>
            {routes.map((route) => (
              <AccordionRouteItem
                key={route.id}
                route={route}
                isSelected={selectedPermissions.includes(route.id)}
                onToggle={onToggleRoute}
                getMethodColor={getMethodColor}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
